import { render, staticRenderFns } from "./tradelistomni.vue?vue&type=template&id=2273fdd3&scoped=true"
import script from "./tradelistomni.vue?vue&type=script&lang=js"
export * from "./tradelistomni.vue?vue&type=script&lang=js"
import style0 from "./tradelistomni.vue?vue&type=style&index=0&id=2273fdd3&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2273fdd3",
  null
  
)

export default component.exports